// Owner/administrator/gebruiker — dezelfde drie niveaus die overal in de app als los rol-icoon
// (domain-owner/administrator/user, zie icon-registry.ts) met tooltip getoond worden. Numerieke
// hiërarchie (1 = hoogste) i.p.v. stringwaarden, zodat de generieke sorteer-/filterpipe
// (filter.pipe.ts) er zonder speciale logica correct op sorteert — een stringwaarde zou alfabetisch
// sorteren ('administrator' < 'gebruiker' < 'owner'), niet naar hiërarchie. accessRoleLabel is de
// losstaande, gebruikersvriendelijke tekst voor weergave/tooltip — bewust een apart veld, want het
// getal zelf mag nooit rechtstreeks getoond worden.
//
// manager (beheerder) bestaat alleen in project-context: het lid met de functie ProjectManager, de
// coördinator van het project. Functioneel heeft hij binnen het project voorrang, dus bovenaan — ook
// boven een owner/administrator uit het domain die expliciet lid is (de hoogste rol = laagste getal
// wint). In domain-context komt manager niet voor; daar blijft de volgorde owner, administrator, user.
export const accessRole = {
    manager: 1,
    owner: 2,
    administrator: 3,
    user: 4,
} as const;

export type TAccessRole = (typeof accessRole)[keyof typeof accessRole];

export const accessRoleLabel: Record<TAccessRole, string> = {
    [accessRole.manager]: 'beheerder',
    [accessRole.owner]: 'owner',
    [accessRole.administrator]: 'administrator',
    [accessRole.user]: 'gebruiker',
};
